import { html } from 'lit';

export const iconProductImage = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="26"
    viewBox="0 0 31 26"
    fill="none"
  >
    <path
      d="M9.70703 5.20964C11.1966 5.20964 12.457 6.47005 12.457 7.95964C12.457 9.50651 11.1966 10.7096 9.70703 10.7096C8.16016 10.7096 6.95703 9.50651 6.95703 7.95964C6.95703 6.47005 8.16016 5.20964 9.70703 5.20964ZM26.6081 0.167969C28.6706 0.167969 30.2747 1.82943 30.2747 3.83464V22.168C30.2747 24.2305 28.6133 25.8346 26.6081 25.8346H4.60807C2.60286 25.8346 0.941406 24.2305 0.941406 22.168V3.83464C0.941406 1.82943 2.60286 0.167969 4.60807 0.167969H26.6081ZM27.5247 21.8242V3.83464C27.5247 3.3763 27.1237 2.91797 26.6081 2.91797H4.60807C4.14974 2.91797 3.69141 3.3763 3.69141 3.83464L3.7487 22.168L8.04557 16.7826C8.27474 16.5534 8.5612 16.3815 8.90495 16.3815C9.2487 16.3815 9.53516 16.5534 9.76432 16.7826L11.8841 19.418L17.957 11.168C18.1862 10.8815 18.4727 10.7096 18.8737 10.7096C19.2174 10.7096 19.5039 10.8815 19.6758 11.168L27.5247 21.8242Z"
      fill="#10509D"
    />
  </svg>
`;
